var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReturnIcon = function SvgReturnIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.5 8a.5.5 0 0 0-1 0zm-13 0a.5.5 0 0 0 1 0zm2.1 3.3a.5.5 0 0 0-.8.6zm8.8-6.6a.5.5 0 1 0 .8-.6zM13.5 8A5.5 5.5 0 0 1 8 13.5v1A6.5 6.5 0 0 0 14.5 8zm-11 0A5.5 5.5 0 0 1 8 2.5v-1A6.5 6.5 0 0 0 1.5 8zM8 13.5c-1.8 0-3.396-.863-4.4-2.2l-.8.6A6.49 6.49 0 0 0 8 14.5zm0-11c1.799 0 3.396.863 4.4 2.2l.8-.6A6.49 6.49 0 0 0 8 1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m13 8 1-1 1 1M3 8 2 9 1 8"
  })));
};
export default SvgReturnIcon;